import React, { useState, useRef } from "react";
import axios from "axios";
import { Upload, Loader2, FileText, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CATEGORIES = [
  { value: "purchase_contract", label: "Purchase Contract" },
  { value: "appraisal", label: "Appraisal" },
  { value: "insurance", label: "Insurance" },
  { value: "title", label: "Title / Lien Search" },
  { value: "financials", label: "Financial Statements" },
  { value: "bank_statements", label: "Bank Statements" },
  { value: "tax_returns", label: "Tax Returns" },
  { value: "entity_docs", label: "Entity Documents" },
  { value: "id_verification", label: "Government ID" },
  { value: "scope_of_work", label: "Scope of Work / Rehab" },
  { value: "closing_docs", label: "Closing Documents" },
  { value: "term_sheet", label: "Term Sheet" },
  { value: "misc", label: "Miscellaneous" },
];

export default function DocumentUploader({ leadId, onUploadComplete }) {
  const [uploading, setUploading] = useState(false);
  const [category, setCategory] = useState("misc");
  const [success, setSuccess] = useState(false);
  const fileRef = useRef(null);
  const token = localStorage.getItem("ic_token");

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setSuccess(false);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("category", category);
    fd.append("description", file.name);
    try {
      await axios.post(`${API}/deals/${leadId}/documents`, fd, {
        headers: { Authorization: `Bearer ${token}` },
        params: { category },
      });
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
      onUploadComplete?.();
    } catch (err) {
      const msg = err.response?.data?.detail || "Upload failed";
      alert(msg);
    }
    setUploading(false);
    if (fileRef.current) fileRef.current.value = "";
  };

  return (
    <div data-testid="document-uploader" className="rounded-xl border border-dashed border-[#ccc] bg-gray-50/30 p-4">
      <div className="flex flex-wrap items-center gap-3">
        <select
          data-testid="doc-category-select"
          value={category}
          onChange={e => setCategory(e.target.value)}
          className="text-sm border border-[#ddd] rounded-lg px-3 py-2 bg-white text-[#333] focus:ring-1 focus:ring-blue-300 outline-none"
        >
          {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>

        <label className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white border border-[#ddd] text-sm text-[#555] hover:border-blue-400 hover:text-blue-600 cursor-pointer transition-colors">
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : success ? <Check className="h-4 w-4 text-emerald-600" /> : <Upload className="h-4 w-4" />}
          {uploading ? "Uploading..." : success ? "Uploaded!" : "Choose File"}
          <input ref={fileRef} type="file" className="hidden" onChange={handleUpload} disabled={uploading} data-testid="doc-upload-input" />
        </label>

        <span className="text-[10px] text-[#aaa]">PDF, DOC, XLS, images (max 25MB)</span>
      </div>
    </div>
  );
}
